/**
 * Copyright (c) 2014, Facebook, Inc. All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
'use strict';

module.exports = function(err) {
  setTimeout(function() {
    throw err;
  }, 0);
};



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/lib/promiseDone.js
// module id = 389
// module chunks = 0